import { Component, OnInit } from '@angular/core';
import { ChartModule } from 'primeng/chart';
import { SkillsService } from '../../../services/skills.service';
import { Skill, SkillAdapter } from '../../../models/skill';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Chart } from 'chart.js';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { catchError, map, of, pipe } from 'rxjs';
import { adaptPagedResponse } from '../../../operators/paged-response-operatros';
import { PagedResponse } from '../../../models/paged-response.model';

Chart.register(ChartDataLabels);

@Component({
  selector: 'app-skill-distribution-widget',
  standalone: true,
  imports: [ChartModule, TranslatePipe],
  templateUrl: './skill-distribution-widget.component.html',
  styleUrls: ['./skill-distribution-widget.component.scss']
})
export class SkillDistributionWidgetComponent implements OnInit {
  data: any = { labels: [], datasets: [{ label: 'people', data: [], backgroundColor: '#42A5F5' }] };
  options: any = {
    indexAxis: 'y',
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      title: { display: false },
      datalabels: {
        anchor: 'end',
        align: 'end',
        color: '#333',
        font: { weight: 'bold' }
      }
    },
    scales: { x: { beginAtZero: true } }
  };
  isLoading = true;
  errorMessage: string | null = null;

  constructor(private skillsService: SkillsService, private skillAdapter: SkillAdapter, private translateService: TranslateService) {}

  ngOnInit() {
    this.isLoading = true;
    this.errorMessage = null;
    this.skillsService.getSkills(1, 1000).pipe(
      // 2. ADAPTATION : L'opérateur fait le map interne (response.items.map(adapt))
            adaptPagedResponse<Skill, Skill>(this.skillAdapter), // 👈 UTILISATION DE L'OPÉRATEUR
            
            // 3. EXTRACTION : On extrait simplement les items du PagedResponse adapté
            map((response: PagedResponse<Skill>) => response.items), 

            // 4. GESTION DU FLUX
            catchError((error: any) => {
                this.translateService.get('DASHBOARD.ERRORS.ERROR_LOADING_SKILLS')
                    .subscribe((translatedMessage: string) => {
                        this.errorMessage = translatedMessage;
                    });
                this.isLoading = false;
                return of([]); 
            })
    ).subscribe({
      next: (skills: Skill[]) => {
        // Trie les skills du plus grand au plus petit nombre de personnes
        const sortedSkills = [...skills].sort(
          (a, b) => (b.peoples?.length || 0) - (a.peoples?.length || 0)
        );
        this.data.labels = sortedSkills.map(skill => skill.name);
        this.data.datasets[0].data = sortedSkills.map(skill =>
          Array.isArray(skill.peoples) ? skill.peoples.length : 0
        );
        this.data = { ...this.data };
        this.isLoading = false;
      },
      error: () => {
        this.translateService.get('DASHBOARD.ERRORS.ERROR_LOADING_SKILLS').subscribe((translatedMessage: string) => {
          this.errorMessage = translatedMessage;
        });
        this.isLoading = false;
      }
    });
  }
}